/**
 * @fileoverview DELETE handler for the "/apps/user_info/:user_identifier/delete_user" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryMutationAdapter } from "../reactQueryFetcherAdapters";
import { appsUserInfoUserIdentifierDeleteUserCacheKeys } from "./constants";
import type { DeleteAppsUserInfoUserIdentifierDeleteUserProps } from "./types";

export const deleteAppsUserInfoUserIdentifierDeleteUser = reactQueryMutationAdapter(
  appsUserInfoUserIdentifierDeleteUserCacheKeys,
  (props: DeleteAppsUserInfoUserIdentifierDeleteUserProps): Promise<{}> => {
    return fetch(`/apps/user_info/${props.userIdentifier}/delete_user`, "DELETE", props, undefined, {
      propagateFetchRequestError: false,
    });
  }
);
